import {connect} from "redux-vue";
import PageTemplate from "./PageTemplate";
import {getScreenSize} from "@/helpers/screens";
import ModuleCard from "../components/ModuleCard";
import classNames from "classnames";

const HomePage = {
  /**
   *
   */
  props: ['user', 'modules'],

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const lg = ['lg', 'xl'].includes( getScreenSize() );

    return (
      <PageTemplate navProps={{fixed: lg, sticky: !lg}}>
        <div class="relative">
          <div class="bg-top bg-cover" style="background-image: url(/img/hero-landing.jpg)">
            <div class="h-56"></div>
            <div class="hidden lg:block h-48"></div>
            <div class="hidden lg:block h-48"></div>
            <div class="absolute bottom-0 left-0 right-0 opacity-75" style={{
              background: "transparent linear-gradient(180deg, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box",
              mixBlenMode: "multiply",
              height: "70%"
            }}></div>
          </div>

          <div class="container mx-auto relative">
            <div
              class="bg-teal-900 lg:bg-transparent relative lg:absolute lg:bottom-0 z-10 px-8 lg:px-0 py-8 lg:py-10">
              <h1 class="text-white text-2xl lg:text-5xl text-center font-serif lg:w-2/3 mx-auto lg:leading-tight">
                Learn new skills. Enhance your career. Protect the health of your community.
              </h1>
              <h2 class="hidden lg:block text-white text-2xl text-center font-serif italic w-2/3 mx-auto my-5">
                With free, self-paced, online courses for health professionals
              </h2>
            </div>
          </div>
        </div>

        <div class="bg-teal-800">
          <div class="container mx-auto py-5">
            {this.modules.fetch && (
              <div class="flex flex-wrap mx-auto" style="opacity: 0.9">
                {Array(4).fill()
                  .map((_, index) => (
                    <div
                      class={classNames(
                        "w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-6 py-3 lg:p-6",
                        index == 1 && "hidden md:block",
                        index == 2 && "hidden lg:block",
                        index == 3 && "hidden xl:block",
                      )}
                    >
                      <div class="bg-white card-loading rounded">
                        <div class="bg-gray-200 h-32"></div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
            <div class="flex flex-wrap mx-auto">
              {this.modules.collection.map(each => (
                <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-6 py-3 lg:p-6">
                  <ModuleCard modelProp={each} key={each.id}/>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div class="bg-teal-100">
          <div class="container mx-auto px-10 lg:px-0 py-12 lg:py-16">
            <h2 class="text-center text-lg lg:text-2xl font-serif italic">
              Enroll in a course and start earning certification right away.
            </h2>
            <div class="flex flex-col lg:flex-row items-center justify-center mt-3 lg:mt-5">
              <router-link to={{name: "RegisterModal"}}
                 class="flex-shrink-0 my-3 lg:my-0 px-3 p-2 lg:p-3 rounded-full font-serif bg-yellow-500 focus:outline-none italic">
                Create an account
                <i class="mdi mdi-arrow-right ml-2"></i>
              </router-link>
              <div class="w-5 h-3"></div>
              <p class="text-sm lg:text-base">
                Existing user? <router-link to={{name: "LoginModal"}} class="text-blue-800 font-semibold">Sign in</router-link>
              </p>
            </div>
          </div>
        </div>
      </PageTemplate>
    )
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    modules: state.modules,
  };
}

function mapActionToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapActionToProps)(HomePage);
